// src/api/file.ts

import type { PresignedResponse } from '@gokrew/models/file';
import api from './client';

/**
 * Uploads a file to a presigned URL.
 */
export async function uploadFileToS3(
  file: File,
  presignedUrl: string
): Promise<void> {
  await fetch(presignedUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  });
}

/**
 * Fetch presigned URL from backend
 */
export async function getPresignedUrl(params: {
  filename: string;
  destination: string;
  /** Size in bytes of the file about to be PUT; the URL then refuses any other size. */
  size?: number;
}): Promise<PresignedResponse> {
  const res = await api.post<{ message: string; data: PresignedResponse }>(
    '/s3/presigned-url',
    params
  );
  return res.data.data;
}
